// extracted by mini-css-extract-plugin
export default {"Service":"Service_Service__dCfp0","ServiceIcon":"Service_ServiceIcon__1UcGJ","ServiceTitle":"Service_ServiceTitle__VhZzj","ServiceText":"Service_ServiceText__EVnYb"};